export default "__VITE_ASSET__596b746e__"